import React from 'react'

export default function AboutMe() {
    return (
        <>
            <div className="backImg">
                <div className="animation">
                    <h1>About Me</h1>
                </div>
            </div>
            <h1 className='text-center pt-5'>Welcome To My Intro !</h1>
            <p className='p-4 text-center'>Hey there, I'm Awais, and I like to think of myself as a web development maestro with a twist. You see, I believe that every line of code I write is a chance to infuse a bit of my personality into the digital landscape. Whether it's crafting elegant solutions for complex problems or meticulously fine-tuning the tiniest design details, I'm all about blending my technical prowess with a touch of creativity. When I'm not deciphering the intricacies of algorithms, you might find me exploring new coffee blends to fuel my coding endeavors or delving into the world of sci-fi novels for a mental escape. My goal as a web developer isn't just to make websites function flawlessly; it's to create online experiences that resonate with the human soul. So, welcome to my corner of the web where I turn lines of code into an expressive art form, weaving your dreams into pixels and interfaces that leave a lasting impact</p>
            <h4 className='text-center'>And a Special Thanks to My Honourable teacher</h4>
            <h3 className='text-center pb-3'><b>Sir Muhammad Umair Ahmad</b></h3>
        </>
    )
}
